import { ProviderStatus } from '@enter/core';
import React from 'react';

interface IStatusDetailProps {
    status: ProviderStatus;
}

export const StatusDetail: React.FunctionComponent<IStatusDetailProps> = (
    _props: IStatusDetailProps,
): React.ReactElement => {
    return <></>;

    // const renderItemCode = (code: StatusItemCode, i: number): React.ReactElement => {
    //     return (
    //         <React.Fragment key={i}>
    //             <S.ExpandTR>
    //                 <S.ExpandTH>Status Code</S.ExpandTH>
    //                 <S.ExpandTD>{code.statusCode}</S.ExpandTD>
    //             </S.ExpandTR>
    //             <S.ExpandTR>
    //                 <S.ExpandTH>Status Category Code</S.ExpandTH>
    //                 <S.ExpandTD>{code.statusCategoryCode}</S.ExpandTD>
    //             </S.ExpandTR>
    //             <S.ExpandTR>
    //                 <S.ExpandTH>Payer Responsibility Type</S.ExpandTH>
    //                 <S.ExpandTD>{renderEnum(code.payerResponsibilityType)}</S.ExpandTD>
    //             </S.ExpandTR>
    //         </React.Fragment>
    //     );
    // };

    // const renderItem = (item: StatusItem, i: number): React.ReactElement => {
    //     return (
    //         <S.ExpandTable key={`status-item-${i}`}>
    //             <S.ExpandTBody>
    //                 <S.ExpandTR>
    //                     <S.ExpandTD colSpan={2}>
    //                         <S.ExpandTitle>Status</S.ExpandTitle>
    //                     </S.ExpandTD>
    //                 </S.ExpandTR>
    //                 <S.ExpandTR>
    //                     <S.ExpandTH>PCN</S.ExpandTH>
    //                     <S.ExpandTD>{item.pcn}</S.ExpandTD>
    //                 </S.ExpandTR>
    //                 <S.ExpandTR>
    //                     <S.ExpandTH>CCN</S.ExpandTH>
    //                     <S.ExpandTD>{item.ccn}</S.ExpandTD>
    //                 </S.ExpandTR>
    //                 <S.ExpandTR>
    //                     <S.ExpandTH>SCN</S.ExpandTH>
    //                     <S.ExpandTD>{item.scn}</S.ExpandTD>
    //                 </S.ExpandTR>
    //                 <S.ExpandTR>
    //                     <S.ExpandTH>Charge Amount</S.ExpandTH>
    //                     <S.ExpandTD>{renderAmount(item.chargeAmount)}</S.ExpandTD>
    //                 </S.ExpandTR>
    //                 <S.ExpandTR>
    //                     <S.ExpandTH>Payer Amount</S.ExpandTH>
    //                     <S.ExpandTD>{renderAmount(item.payerAmount)}</S.ExpandTD>
    //                 </S.ExpandTR>
    //                 <S.ExpandTR>
    //                     <S.ExpandTH>Units</S.ExpandTH>
    //                     <S.ExpandTD>{item.units}</S.ExpandTD>
    //                 </S.ExpandTR>
    //                 <S.ExpandTR>
    //                     <S.ExpandTH>Remittance Date</S.ExpandTH>
    //                     <S.ExpandTD>{renderDate(item.remittanceDate)}</S.ExpandTD>
    //                 </S.ExpandTR>
    //                 <S.ExpandTR>
    //                     <S.ExpandTH>Finalized Date</S.ExpandTH>
    //                     <S.ExpandTD>{renderDate(item.finalizedDate)}</S.ExpandTD>
    //                 </S.ExpandTR>
    //                 <S.ExpandTR>
    //                     <S.ExpandTH>Service From Date</S.ExpandTH>
    //                     <S.ExpandTD>{renderDate(item.serviceFromDate)}</S.ExpandTD>
    //                 </S.ExpandTR>
    //                 <S.ExpandTR>
    //                     <S.ExpandTH>Service Through Date</S.ExpandTH>
    //                     <S.ExpandTD>{renderDate(item.serviceThroughDate)}</S.ExpandTD>
    //                 </S.ExpandTR>
    //                 <S.ExpandTR>
    //                     <S.ExpandTH>Procedure Code</S.ExpandTH>
    //                     <S.ExpandTD>{item.procedureCode}</S.ExpandTD>
    //                 </S.ExpandTR>
    //                 <S.ExpandTR>
    //                     <S.ExpandTD colSpan={2}>
    //                         <S.ExpandTitle>Items</S.ExpandTitle>
    //                     </S.ExpandTD>
    //                 </S.ExpandTR>
    //                 {_.map(item.statuses, renderItemCode)}
    //                 <S.ExpandTR>
    //                     <S.ExpandTH>Status Effective Date</S.ExpandTH>
    //                     <S.ExpandTD>{renderDate(item.statusEffectiveDate)}</S.ExpandTD>
    //                 </S.ExpandTR>
    //                 <S.ExpandTR>
    //                     <S.ExpandTH>Check Number</S.ExpandTH>
    //                     <S.ExpandTD>{item.checkNumber}</S.ExpandTD>
    //                 </S.ExpandTR>
    //             </S.ExpandTBody>
    //         </S.ExpandTable>
    //     );
    // };

    // return <S.ExpandCol>{_.map(status.items, (item, i) => renderItem(item, i))}</S.ExpandCol>;
};
